let newdomain = process.env.VUE_APP_BACKEND;

export function curl(data) {
    return fetch(data.url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data.body)
    })
        .then(response => { return response })

        .catch(error => {
            console.log('Error:', error);
        });
}

export function VerificarExistenciaEmp(data) {
    return fetch(newdomain + '/buscarEmpleado', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .then(data => {
            return data;
        })

        .catch(error => {
            console.log('Error:', error);
        });
}

export function validarPIN(data) {
    return fetch(newdomain + '/validarPin', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .then(data => {
            return data;
        })

        .catch(error => {
            console.log('Error:', error);
        });
}

export function obtenerEmpleados(data) {
    return fetch(newdomain + '/obtenerEmpleados', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .then(data => {
            return data;
        })

        .catch(error => {
            console.log('Error:', error);
        });
}

export function obtenerUltimosArchivos(token) {
    let data = {
        token
    }
    return fetch(newdomain + '/UltimosArchivos', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
    })
        .then(response => response.json())
        .then(data => {
            return data;
        })

        .catch(error => {
            console.log('Error:', error);
        });
}

export function obtenerMisArchivos(token) {
    let data = {
        token
    }
    return fetch(newdomain + '/ObtenerMisArchivos', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
    })
        .then(response => response.json())
        .then(data => {
            return data;
        })

        .catch(error => {
            console.log('Error:', error);
        });
}

export function descargarArchivos(token, documento) {
    let data = {
        token,
        documento
    }
    return fetch(newdomain + '/entidad/empleados/sinAuth/DescargarArchivo', {
        method: 'POST',
        body: JSON.stringify(data),
    })
        .then(response => {
            if (response.ok) {
                return response.blob();
            }
            throw new Error('Error en la descarga.');
        })
        .then(blob => {
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = 'archivo.pdf'; // Nombre del archivo descargado
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        })
        .catch(error => {
            console.error(error);
        });
}